import { useTranslation } from 'react-i18next'

import { EarthIcon } from '@pleio/icons/earth'
import { EyeOffIcon } from '@pleio/icons/eye-off'
import { GroupIcon } from '@pleio/icons/group'
import { LogOutIcon } from '@pleio/icons/log-out'
import { UsersIcon } from '@pleio/icons/users'

export function useAccessTitle(access: string) {
    const { t } = useTranslation()

    const accessTitle =
        access === 'administrator'
            ? 'permissions.administrators'
            : access === 'loggedIn'
              ? 'permissions.logged-in-users'
              : access === 'publicOnly'
                ? 'permissions.logged-out'
                : access === 'members'
                  ? 'permissions.members'
                  : 'permissions.public'

    return t(accessTitle)
}

export interface Props {
    access: 'administrator' | 'loggedIn' | 'public' | 'publicOnly' | 'members'
}

export const AccessIcon = ({ access, ...rest }: Props) => {
    const icons = {
        administrator: <EyeOffIcon {...rest} />,
        loggedIn: <UsersIcon {...rest} />,
        public: <EarthIcon {...rest} />,
        publicOnly: <LogOutIcon {...rest} />,
        members: <GroupIcon {...rest} />,
    }
    return icons[access] || null
}
